import React from 'react';
import { Line } from '@react-pdf/renderer';
import { AssessmentPDFStyles } from '../AssessmentPDFStyles';

const Hr = () => <Line style={AssessmentPDFStyles.hr} />;

export default Hr;
